var _style, _g, _defs, _rect, _defs2, _defs3, _rect2, _rect3, _defs4, _defs5, _rect4, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTahweelargiculture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 310.5 93.7",
    style: {
      enableBackground: "new 0 0 310.5 93.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#005F83;}\n\t.st2{display:inline;fill:#50B6DF;}\n\t.st3{display:inline;}\n\t.st4{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n\t.st5{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st6{clip-path:url(#SVGID_5_);}\n\t.st7{enable-background:new    ;}\n\t.st8{clip-path:url(#SVGID_5_);fill:url(#SVGID_7_);}\n\t.st9{clip-path:url(#SVGID_5_);mask:url(#SVGID_6_);}\n\t.st10{clip-path:url(#SVGID_9_);}\n\t.st11{clip-path:url(#SVGID_11_);fill:url(#SVGID_12_);}\n\t.st12{fill:#008D45;}\n\t.st13{fill:#FFFFFF;}\n\t.st14{fill:#58595B;}\n\t.st15{fill:#6D6E71;}\n\t.st16{fill:#8BAF44;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.5-52.8H106c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h6.2c0.1,0,0.2,0.1,0.2,0.3V-31 c0,0.7,0.6,1.3,1.3,1.3h0.1c0.7,0,1.3-0.6,1.3-1.3v-19.1c0-0.1,0.1-0.3,0.2-0.3h6.2c0.7,0,1.3-0.6,1.3-1.3 C122.8-52.3,122.2-52.8,121.5-52.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.4-38.5c0,0-0.1,0.1-0.2,0.1h-9.3c-0.1,0-0.2-0.1-0.2-0.1c0,0-0.1-0.1,0-0.2l4.7-10.2 c0.1-0.1,0.2-0.1,0.2-0.1h0c0,0,0.2,0,0.2,0.1l4.6,10.2C142.4-38.7,142.4-38.6,142.4-38.5 M139-52.3c-0.2-0.4-0.7-0.7-1.1-0.7h-0.6 c-0.5,0-0.9,0.3-1.1,0.7l-9.6,20.7c-0.2,0.4-0.2,0.8,0.1,1.2c0.2,0.4,0.6,0.6,1.1,0.6c0.5,0,0.9-0.3,1.2-0.7l2.4-5.3l0.2-0.1h12.1 l0.2,0.1l2.4,5.3c0.2,0.5,0.7,0.7,1.2,0.7h0.1c0.4,0,0.8-0.2,1.1-0.6c0.2-0.4,0.3-0.8,0.1-1.2L139-52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.9-52.8h-0.1c-0.7,0-1.3,0.6-1.3,1.3v8.7c0,0.1-0.1,0.2-0.3,0.2h-12.6c-0.1,0-0.3-0.1-0.3-0.2v-8.7 c0-0.7-0.6-1.3-1.3-1.3H158c-0.7,0-1.3,0.6-1.3,1.3V-31c0,0.7,0.6,1.3,1.3,1.3h0.1c0.7,0,1.3-0.6,1.3-1.3v-8.8 c0-0.1,0.1-0.2,0.3-0.2h12.6c0.1,0,0.3,0.1,0.3,0.2v8.8c0,0.7,0.6,1.3,1.3,1.3h0.1c0.7,0,1.3-0.6,1.3-1.3v-20.6 C175.2-52.3,174.6-52.8,173.9-52.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214-52.8L214-52.8c-0.6,0-1.1,0.3-1.3,0.8l-6,17.1c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1,0-0.2,0-0.2-0.2L200.6-52 c-0.2-0.5-0.7-0.9-1.2-0.9h-0.2c-0.5,0-1,0.3-1.2,0.9L192.4-35c-0.1,0.2-0.2,0.2-0.2,0.2c-0.1,0-0.2,0-0.2-0.2l-6-17.1 c-0.2-0.5-0.7-0.8-1.2-0.8h-0.2c-0.4,0-0.8,0.2-1,0.5c-0.2,0.3-0.3,0.8-0.2,1.2l7.5,20.7c0.2,0.5,0.7,0.8,1.2,0.8h0.2 c0.5,0,1-0.3,1.2-0.9L199-47c0.1-0.2,0.2-0.2,0.2-0.2c0.1,0,0.2,0,0.2,0.2l5.6,16.5c0.2,0.5,0.7,0.9,1.2,0.9h0.2 c0.5,0,1-0.3,1.2-0.8l7.5-20.7c0.1-0.4,0.1-0.8-0.2-1.2C214.8-52.6,214.4-52.8,214-52.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239-32.3h-12.7c-0.1,0-0.2-0.1-0.2-0.2v-7.4c0-0.1,0.1-0.2,0.2-0.2h11.1c0.7,0,1.3-0.6,1.3-1.3 c0-0.7-0.6-1.3-1.3-1.3h-11.1c-0.1,0-0.2-0.1-0.2-0.2v-7.2c0-0.1,0.1-0.2,0.2-0.2h12.6c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3 h-14.2c-0.7,0-1.3,0.6-1.3,1.3V-31c0,0.7,0.6,1.3,1.3,1.3H239c0.7,0,1.3-0.6,1.3-1.3C240.2-31.7,239.7-32.3,239-32.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.1-32.3h-12.7c-0.1,0-0.3-0.1-0.3-0.2v-7.4c0-0.1,0.1-0.2,0.3-0.2h11.1c0.7,0,1.3-0.6,1.3-1.3 c0-0.7-0.6-1.3-1.3-1.3h-11.1c-0.1,0-0.3-0.1-0.3-0.2v-7.2c0-0.1,0.1-0.2,0.3-0.2h12.6c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3 h-14.2c-0.7,0-1.3,0.6-1.3,1.3V-31c0,0.7,0.6,1.3,1.3,1.3h14.4c0.7,0,1.3-0.6,1.3-1.3C265.3-31.7,264.8-32.3,264.1-32.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.9-32.3h-11.5c-0.1,0-0.3-0.1-0.3-0.2v-19.1c0-0.7-0.6-1.3-1.3-1.3h-0.1c-0.7,0-1.3,0.6-1.3,1.3V-31 c0,0.7,0.6,1.3,1.3,1.3h13.1c0.7,0,1.3-0.6,1.3-1.3C289.1-31.7,288.6-32.3,287.9-32.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180.6-21.8h-10.3c-0.6,0-1.1,0.5-1.1,1.1v15.1c0,0.6,0.5,1.1,1.1,1.1h0.1c0.6,0,1.1-0.5,1.1-1.1v-6.2l0,0h8 c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-8l0,0v-5.5l0,0h9.1c0.6,0,1.1-0.5,1.1-1.1C181.6-21.3,181.2-21.8,180.6-21.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M186.8-21.8L186.8-21.8c-0.7,0-1.2,0.5-1.2,1.1v15.1c0,0.6,0.5,1.1,1.1,1.1h0.1c0.6,0,1.1-0.5,1.1-1.1v-15.1 C187.9-21.3,187.4-21.8,186.8-21.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M203.6-6.7h-8.4l0,0v-14c0-0.6-0.5-1.1-1.1-1.1H194c-0.6,0-1.1,0.5-1.1,1.1v15.1c0,0.6,0.5,1.1,1.1,1.1h9.6 c0.6,0,1.1-0.5,1.1-1.1C204.7-6.2,204.2-6.7,203.6-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M223.6-21.8h-0.3c-0.4,0-0.7,0.2-0.9,0.5l-5.9,8.7h-0.1l-5.9-8.7c-0.2-0.3-0.5-0.5-0.9-0.5h-0.3 c-0.6,0-1.1,0.5-1.1,1.1v15.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1v-11.7l0.1,0l5.5,8.1h0.6l5.5-8.1l-0.4-0.3l0.5,0.3v11.7 c0,0.6,0.5,1.1,1.1,1.1h0.1c0.6,0,1.1-0.5,1.1-1.1v-15.1C224.7-21.3,224.2-21.8,223.6-21.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.9-9.8c-0.6,0-1.2-0.3-1.5-0.8C5.1-17.8,2.9-26,2.9-34.4c0-25.6,20.8-46.4,46.4-46.4c8.6,0,17,2.4,24.3,6.9 c0.8,0.5,1.1,1.6,0.6,2.4c-0.5,0.8-1.6,1.1-2.4,0.6c-6.8-4.2-14.5-6.4-22.5-6.4c-23.7,0-42.9,19.2-42.9,42.9c0,7.8,2.1,15.4,6.1,22 c0.5,0.8,0.2,1.9-0.6,2.4C11.5-9.9,11.2-9.8,10.9-9.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.2,10.5c-15.7,0-30.5-8.4-38.6-21.9c-0.1-0.1,0-0.3,0.1-0.4c0.1-0.1,0.3,0,0.4,0.1 c8,13.3,22.6,21.6,38.1,21.6c24.4,0,44.3-19.9,44.3-44.3c0-15.5-7.9-29.6-21.1-37.7c-0.1-0.1-0.2-0.3-0.1-0.4 c0.1-0.1,0.3-0.2,0.4-0.1c13.4,8.3,21.3,22.5,21.3,38.2C94.1-9.7,74,10.5,49.2,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.2,1.7c-5.6,0-11.2-1.3-16.2-3.8c-0.9-0.4-1.2-1.5-0.8-2.3c0.4-0.9,1.5-1.2,2.3-0.8 C41.2-1.9,48.9-1,56.2-2.6c5.9-1.3,11.3-4.2,15.7-8.4c12.9-12.5,13.2-33.2,0.7-46.1c-4.1-4.2-9.3-7.3-15-8.8 c-0.9-0.2-1.5-1.2-1.2-2.1c0.2-0.9,1.2-1.5,2.1-1.2c6.3,1.7,12,5,16.5,9.7c13.9,14.3,13.5,37.2-0.8,51C69.5-3.8,63.5-0.6,57,0.8 C54.4,1.4,51.8,1.7,49.2,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.8-3.4l-0.1,0c-3.5-1.7-6.6-4-9.3-6.9C11-24,11.4-46,25.1-59.3c8.7-8.4,21.4-11.7,33.1-8.6 c0.2,0,0.2,0.2,0.2,0.4c0,0.2-0.2,0.2-0.4,0.2c-11.5-3.1-24,0.2-32.6,8.5C12-45.8,11.7-24.2,24.8-10.7c2.7,2.8,5.8,5,9.2,6.7 c0.1,0.1,0.2,0.2,0.1,0.4C34-3.5,33.9-3.4,33.8-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.1-53H35.3c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2h10.2v30.9c0,1.8,1.4,3.2,3.2,3.2 c1.8,0,3.2-1.4,3.2-3.2v-30.9h10.2c1.8,0,3.2-1.4,3.2-3.2C65.3-51.6,63.9-53,62.1-53"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M49.2,20c-13.9,9.3-17.6,28.1-8.3,42c9.3,13.9,28.1,17.6,42,8.3c13.9-9.3,17.6-28.1,8.3-42 c-5.8-8.7-15.4-13.4-25.2-13.4C60.3,14.9,54.4,16.6,49.2,20"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: -122.7717,
    cy: 526.7979,
    r: 1.2441,
    gradientTransform: "matrix(24.3445 0 0 24.3445 3054.917 -12779.3994)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#76AB3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#008D45"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.6,
    y: 14.9,
    className: "st4",
    width: 68.9,
    height: 64.8
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M50.1,21.4C36.9,30.2,33.4,48,42.2,61.2c8.8,13.2,26.7,16.7,39.8,7.9c13.2-8.8,16.7-26.7,7.9-39.8 C84.4,21,75.3,16.5,66.1,16.5C60.6,16.5,55,18.1,50.1,21.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 33.4,
    y: 16.5,
    width: 65.4,
    height: 61.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 33.4,
    y: 16.5,
    width: 65.4,
    height: 61.4,
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.4,
    y: 16.5,
    className: "st6",
    width: 65.4,
    height: 61.4
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -124.1761,
    y1: 520.6936,
    x2: -122.9319,
    y2: 520.6936,
    gradientTransform: "matrix(46.1661 0 0 46.1661 5770.0903 -23991.2012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01206395,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03395503,
    style: {
      stopColor: "#BDBCBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05854917,
    style: {
      stopColor: "#989697"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0853065,
    style: {
      stopColor: "#787676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1149,
    style: {
      stopColor: "#5D5A5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1483,
    style: {
      stopColor: "#484445"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1873,
    style: {
      stopColor: "#373334"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2355,
    style: {
      stopColor: "#2C2829"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3031,
    style: {
      stopColor: "#252122"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4909,
    style: {
      stopColor: "#231F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6856,
    style: {
      stopColor: "#252122"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7558,
    style: {
      stopColor: "#2C2829"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8058,
    style: {
      stopColor: "#373334"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8462,
    style: {
      stopColor: "#484445"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8809,
    style: {
      stopColor: "#5D5A5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9115,
    style: {
      stopColor: "#787676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9393,
    style: {
      stopColor: "#989697"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9648,
    style: {
      stopColor: "#BDBCBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9875,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.4,
    y: 16.5,
    className: "st8",
    width: 65.4,
    height: 61.4
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_8_",
    x: 33.4,
    y: 16.5,
    width: 65.4,
    height: 61.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_10_",
    x: 33.4,
    y: 16.5,
    width: 65.4,
    height: 61.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -124.1761,
    y1: 520.6936,
    x2: -122.9319,
    y2: 520.6936,
    gradientTransform: "matrix(46.1661 0 0 46.1661 5770.0903 -23991.2012)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06938463,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4909,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.4,
    y: 16.5,
    className: "st11",
    width: 65.4,
    height: 61.4
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M36.6,18.8c2.1-2.4,4.6-4.6,7.4-6.5c17.6-11.8,41.3-7.6,53.8,9.3c0.5-0.7,1.1-1.3,1.9-1.7 c1-0.7,2.1-1.1,3.2-1.2C88.7-1.1,61.2-6.2,40.8,7.5c-3.4,2.3-6.5,5-9.1,8C33.7,15.9,35.4,17,36.6,18.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M109.6,32.3c-0.3,0.3-0.6,0.6-1,0.8c-1.4,0.9-2.9,1.3-4.4,1.3c4.5,16-1.5,33.8-16.1,43.6 c-4.6,3.1-9.7,5.1-14.8,6c1,1.8,1.2,3.9,0.7,5.8c6-1.1,11.9-3.4,17.4-7C108.3,71.6,115.1,50.9,109.6,32.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M59.3,84.2c-10.3-1.8-19.8-7.6-26.1-17c-7.4-11.1-8.5-24.5-4.1-36.1c-2-0.2-3.8-1.2-5.1-2.8 c-5.4,13.4-4.2,29.2,4.4,42.1C35.6,81.3,46.7,88,58.6,90C58.1,88,58.3,86,59.3,84.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M69.6,92.9c-2.7,1.8-6.4,1.1-8.2-1.6c-1.8-2.7-1.1-6.4,1.6-8.2c2.7-1.8,6.4-1.1,8.2,1.6 C73.1,87.4,72.3,91,69.6,92.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M107.5,31.4c-2.7,1.8-6.4,1.1-8.2-1.6c-1.8-2.7-1.1-6.4,1.6-8.2c2.7-1.8,6.4-1.1,8.2,1.6 C110.9,25.9,110.2,29.6,107.5,31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M33.4,28.2c-2.7,1.8-6.4,1.1-8.2-1.6c-1.8-2.7-1.1-6.4,1.6-8.2c2.7-1.8,6.4-1.1,8.2,1.6 C36.8,22.7,36.1,26.4,33.4,28.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M61.9,62.1V30.7h-2.9c-2,0-3.4,0.2-4,0.7c-0.6,0.5-0.9,1.4-0.9,2.9v1.5H50v-4.3v-4.3h16.1h16.1v4.3v4.3 h-4.1v-1.5c0-1.5-0.3-2.4-0.9-2.9c-0.6-0.5-2-0.7-4-0.7h-2.9v31.3c0,0.7,0.2,1.2,0.6,1.5c0.4,0.3,1.1,0.5,2,0.5h2.5v3.5h-9.3 h-9.3v-3.5h2.5c1,0,1.6-0.1,2-0.5C61.7,63.3,61.9,62.8,61.9,62.1"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M128.6,32.7c0,2.4,0.1,8.2,0.1,9.2c0,3.6,3,6.5,6.5,6.5c3.5,0,6.5-2.9,6.5-6.5l-0.2-26h6.3l0,19.5 c0,2.7,2.1,3.7,3.1,3.7h4.3v5.5h-4.6c-1.2,0-2.1-0.3-2.9-0.8c-0.9,5.9-6.2,10.5-12.5,10.5c-7.1,0-12.7-5.6-12.7-12.4 c0-1.3-0.2-6.5-0.2-9.2H128.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M161.6,44.6h-7.1v-5.5h5.3c1.3,0,2.3-0.7,2.3-2.1c0-3.1,0-6.2-0.1-9.2h6.3c0,5,0.1,6.3,0.1,10.6 C168.4,42.2,166.1,44.6,161.6,44.6 M154.8,48.1h5.4v5.2h-5.4V48.1z M162.4,48.1h5.4v5.2h-5.4V48.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M191,44.6c-1.6,5.2-5.9,9-12.1,9.5c-1.8-2-2.3-2.7-4.3-4.7c3.3-0.2,7.7-2,9.6-4.7h-2.2 c-4.9,0-7.9-4.3-7.9-8.2c0-6.7,5.5-8.6,8.9-8.6c1,0,8.1,0.4,8.6,7c0,0.2,0,1.1,0,4.3h5.3v5.5H191z M185.4,35.4 c0-1.6-0.3-3.2-2.4-3.2c-1.9,0-3,1.8-3,3.6c0,1.7,0.9,3.3,2.8,3.3h2.6V35.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.3,
    y: 39.1,
    className: "st12",
    width: 10.3,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.8,
    y: 39.1,
    className: "st12",
    width: 10.3,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.3,
    y: 39.1,
    className: "st12",
    width: 10.3,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.8,
    y: 39.1,
    className: "st12",
    width: 10.3,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.4,
    y: 39.1,
    className: "st12",
    width: 10.3,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.9,
    y: 39.1,
    className: "st12",
    width: 10.3,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M251.4,44.6v-5.5h19.7c-1.1-3.6-3.8-5.8-7-5.8c-4,0-6.1,2-6.1,2l-2.5-4.4c0.8-0.9,3.5-3.1,8.5-3.1 c7.4,0,11.5,5.3,12.9,11.3h4.7v5.5H251.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M288.1,44.6H281v-5.5h5.3c1.4,0,2.3-0.7,2.3-2.1c0-3.1,0-6.2-0.1-9.2h6.3c0,5,0.1,6.3,0.1,10.6 C294.9,42.2,292.6,44.6,288.1,44.6 M281.3,19.1h5.4v5.2h-5.4V19.1z M288.9,19.1h5.4v5.2h-5.4V19.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M130.7,74.8c-1.1,0-1.9-0.3-2.5-1c-0.7,0.4-1.6,0.6-2.6,0.6c-2.1,0-3.4-1.5-3.4-3.9c0-1.3,0.4-2.3,1.3-3.1 c0.9-0.8,2-1.2,3.4-1.2h0.6l-0.1-0.9c0.9-0.2,1.7-0.4,2.4-0.5v6.7c0,1.1,0.5,1.6,1.5,1.6h1.3v1.8H130.7z M126.2,62.7 c0,0.6-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2C125.7,61.4,126.2,61.9,126.2,62.7z M127.7,67.4 c-0.4,0-0.7,0-1.1,0c-0.7,0-1.3,0.3-1.8,0.8c-0.5,0.5-0.7,1.1-0.7,1.9c0,1.7,0.6,2.6,1.9,2.6c0.6,0,1.2-0.1,1.7-0.2V67.4z  M129.4,62.7c0,0.6-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2C128.9,61.4,129.4,61.9,129.4,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M134.2,78c0,0.6-0.5,1.2-1.2,1.2c-0.6,0-1.2-0.5-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2 C133.6,76.8,134.2,77.3,134.2,78z M139.6,74.8h-1.5c-0.8,0-1.5-0.2-2-0.6c-0.5,0.4-1.2,0.6-1.9,0.6h-2.4V73h1.9 c1,0,1.5-0.5,1.5-1.6v-2.1l-0.4-2.6l2.4-0.5v5.1c0,1.1,0.5,1.6,1.5,1.6h1V74.8z M137.4,78c0,0.6-0.5,1.2-1.2,1.2 c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2C136.8,76.8,137.4,77.3,137.4,78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M151.5,74.8H139V73h8.6c-0.5-1.1-1.1-2.2-2-3.4c-1.1-1.5-2.1-2.2-2.9-2.2c-0.6,0-0.9,0.4-0.9,1.1 c0,0.4,0.1,0.8,0.3,1.3l-2.1,0.2c0.2-2.6,1.6-4.2,3.3-4.2c1.4,0,2.7,0.9,4.1,2.6c1.1,1.4,1.9,2.9,2.5,4.5h1.5V74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M167.9,74.8h-14.5h-0.1h-2.3V73h1.8c1,0,1.4-0.5,1.4-1.6l0-3.9l2-0.4v4c2.1-3.1,4.4-4.7,6.9-4.7 c1.4,0,2.6,0.3,3.5,1c0.9,0.6,1.4,1.5,1.4,2.7V74.8z M165.9,70.4c0-1.5-1.1-2.3-3.3-2.3c-1.2,0-2.5,0.7-3.8,2c-1,1.1-1.7,2-2,2.8 h9V70.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M189,71.9c0,1.8-1.1,2.9-2.9,2.9h-9c-1.1,0-2.1-0.4-2.7-1.2c-0.7-0.8-1-1.8-1-3.1c0-1,0.3-1.9,0.8-2.8h1.8 c-0.6,0.9-0.9,1.7-0.9,2.4c0,1.9,0.8,2.9,2.4,2.9h8.2c1,0,1.5-0.5,1.5-1.6v-2l-0.4-2.6l2.3-0.5V71.9z M180.9,66.4 c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2C180.3,65.2,180.9,65.7,180.9,66.4z M184.1,66.4 c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2C183.5,65.2,184.1,65.7,184.1,66.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M193.7,61.9l-0.2,2.7v10.2h-2V64.6l-0.3-2.5L193.7,61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M204.6,74.8h-8.9l0.5-1.8h5l0.1-0.4v-2.1c0-1-0.2-1.7-0.6-2.3c-0.4-0.5-0.8-0.8-1.4-0.8 c-0.2,0-0.4,0-0.6,0.1c0-0.2,0-0.6-0.1-1.1c0.1,0,0.3,0,0.6-0.1c1.2,0,2.2,0.4,2.9,1.3c0.7,0.8,1.1,1.9,1.1,3.2V73v0h1.3V74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M206.4,78c0,0.6-0.5,1.2-1.2,1.2c-0.6,0-1.2-0.5-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2 C205.8,76.8,206.4,77.3,206.4,78z M210.1,71.9c0,1.8-1.1,2.9-3,2.9h-3.1V73h2.6c1,0,1.5-0.5,1.5-1.6v-2l-0.3-2.6l2.3-0.5V71.9z  M209.5,78c0,0.6-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C209,76.8,209.5,77.3,209.5,78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M221.2,74.8h-8.9l0.5-1.8h5l0.1-0.4v-2.1c0-1-0.2-1.7-0.6-2.3c-0.4-0.5-0.8-0.8-1.4-0.8 c-0.2,0-0.4,0-0.6,0.1c0-0.2,0-0.6-0.1-1.1c0.1,0,0.3,0,0.6-0.1c1.2,0,2.2,0.4,2.9,1.3c0.7,0.8,1.1,1.9,1.1,3.2V73v0h1.3V74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M233.7,74.8h-1.4c-0.7,0-1.4-0.2-1.9-0.6c-1,1.2-2.2,1.7-3.5,1.7c-1.1,0-2-0.5-2.6-1.5 c-0.4,0.2-0.9,0.4-1.5,0.4h-2.1V73h1.5c0.9,0,1.4-0.4,1.4-1.3c0.1-2.9,2-4.6,5-4.6c1,0,1.9,0.2,2.9,0.5l-0.2,2.1v1.8 c0,1.1,0.5,1.6,1.5,1.6h1V74.8z M229.3,73.4v-3.7l-0.2-1.1c-0.3-0.1-0.6-0.1-1-0.1c-1.7,0-2.5,1-2.5,3.1c0,1.7,0.7,2.7,1.7,2.7 C228.1,74.3,228.7,74,229.3,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M239.2,71.9c0,1.8-1.1,2.9-3,2.9h-3.1V73h2.6c1,0,1.5-0.5,1.5-1.6v-2l-0.3-2.6l2.3-0.5V71.9z M236.2,63.2 c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2C235.6,61.9,236.2,62.5,236.2,63.2z M239.4,63.2 c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2C238.8,61.9,239.4,62.5,239.4,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M252.8,74.8c-1.1,0-1.9-0.3-2.5-1c-0.7,0.4-1.6,0.6-2.6,0.6c-2.1,0-3.4-1.5-3.4-3.9c0-1.3,0.4-2.3,1.3-3.1 c0.9-0.8,2-1.2,3.4-1.2h0.6l-0.1-0.9c0.9-0.2,1.7-0.4,2.4-0.5v6.7c0,1.1,0.5,1.6,1.5,1.6h1.3v1.8H252.8z M248.4,62.7 c0,0.6-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2C247.9,61.4,248.4,61.9,248.4,62.7z M249.9,67.4 c-0.4,0-0.7,0-1.1,0c-0.7,0-1.3,0.3-1.8,0.8c-0.5,0.5-0.7,1.1-0.7,1.9c0,1.7,0.6,2.6,1.9,2.6c0.6,0,1.2-0.1,1.7-0.2V67.4z  M251.6,62.7c0,0.6-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.6,0.5-1.2,1.2-1.2C251,61.4,251.6,61.9,251.6,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M267,74.8h-1.4c-0.7,0-1.4-0.2-1.9-0.6c-1,1.2-2.2,1.7-3.5,1.7c-1.1,0-2-0.5-2.6-1.5 c-0.4,0.2-0.9,0.4-1.5,0.4H254V73h1.5c0.9,0,1.4-0.4,1.4-1.3c0.1-2.9,2-4.6,5-4.6c1,0,1.9,0.2,2.9,0.5l-0.2,2.1v1.8 c0,1.1,0.5,1.6,1.5,1.6h1V74.8z M262.6,73.4v-3.7l-0.2-1.1c-0.3-0.1-0.6-0.1-1-0.1c-1.7,0-2.5,1-2.5,3.1c0,1.7,0.7,2.7,1.7,2.7 C261.4,74.3,262,74,262.6,73.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M284.6,74.8h-18.1V73h3v-7.8l-0.3-2.5l2.5-0.2l-0.2,2.6V71c0.6-1.1,1.4-2.1,2.6-3c1.4-1.1,2.7-1.7,4-1.7 c1.4,0,2.5,0.3,3.4,1c0.9,0.7,1.4,1.5,1.4,2.7V73h1.9V74.8z M280.7,73v-2.7c0-1.5-1.1-2.3-3.2-2.3c-1.1,0-2.4,0.7-3.8,2 c-1.2,1.1-1.9,2.1-2.2,3H280.7z M278.9,63.2c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2 C278.4,61.9,278.9,62.5,278.9,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M290.1,71.9c0,1.8-1.1,2.9-3,2.9h-3.1V73h2.6c1,0,1.5-0.5,1.5-1.6v-2l-0.3-2.6l2.3-0.5V71.9z M289,63.2 c0,0.7-0.5,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2C288.4,61.9,289,62.5,289,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M295.3,61h-4.1v-0.7h0.7c0-1.1,0.6-1.9,1.6-1.9c0.4,0,0.8,0.1,1.2,0.4c-0.1,0.2-0.1,0.4-0.2,0.6 c-0.3-0.3-0.5-0.4-0.7-0.4c-0.6,0-0.8,0.4-0.8,1.3h1l0.7-0.1L295.3,61z M294.8,61.9l-0.2,2.7v10.2h-2V64.6l-0.3-2.5L294.8,61.9z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M137.6,20.9h-15.9c-1.1,0-2.1,0.9-2.1,2.1c0,0.3,0.2,0.5,0.5,0.5h7.4v19c0,1.1,0.9,2.1,2.1,2.1h0.1 c0.3,0,0.5-0.2,0.5-0.5V23.5h5.8c1.1,0,2.1-0.9,2.1-2.1C138.2,21.2,137.9,20.9,137.6,20.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M154.6,21.1c-0.1-0.2-0.3-0.3-0.5-0.3c-1.2,0-2.3,0.7-2.8,1.8l-9.1,19.7c-0.2,0.5-0.2,1.1,0.1,1.6 c0.3,0.5,0.8,0.8,1.4,0.8c0.2,0,0.4-0.1,0.5-0.3l2.7-6h12.7l2.2,4.8c0.4,0.9,1.4,1.5,2.4,1.5h0.5c0.2,0,0.3-0.1,0.4-0.2 c0.1-0.1,0.1-0.3,0-0.5L154.6,21.1z M158.4,35.7h-10.3l5.2-11.3L158.4,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M191.3,20.9c-1.2,0-2.2,1-2.2,2.2v8.3h-13.4v-9.9c0-0.3-0.2-0.5-0.5-0.5c-1.2,0-2.2,1-2.2,2.2V44 c0,0.3,0.2,0.5,0.5,0.5c1.2,0,2.2-1,2.2-2.2V34h13.4V44c0,0.3,0.2,0.5,0.5,0.5c1.2,0,2.2-1,2.2-2.2V21.4 C191.9,21.2,191.6,20.9,191.3,20.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M230.2,22.1l-6.3,17.8l-6.3-19.1h-0.7c-0.8,0-1.5,0.5-1.7,1.3l-5.9,17.8l-6.7-19h-0.4c-0.6,0-1.2,0.3-1.5,0.8 c-0.3,0.5-0.4,1.1-0.2,1.7l7.7,21.3h0.4c1,0,2-0.7,2.3-1.6l5.7-16.9l6.1,18.1l0.1,0.4h0.4c1,0,1.9-0.6,2.3-1.6l8-22.2H232 C231.2,20.9,230.5,21.4,230.2,22.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M256.5,41.9H244v-8h12.5c0.3,0,0.5-0.2,0.5-0.5c0-1.1-0.9-2.1-2.1-2.1H244v-7.8h13.9c0.3,0,0.5-0.2,0.5-0.5 c0-1.1-0.9-2.1-2.1-2.1h-14.6c-0.3,0-0.5,0.2-0.5,0.5V44c0,0.3,0.2,0.5,0.5,0.5h16.3c0.3,0,0.5-0.2,0.5-0.5 C258.6,42.9,257.6,41.9,256.5,41.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M282.2,41.9h-12.5v-8h12.5c0.3,0,0.5-0.2,0.5-0.5c0-1.1-0.9-2.1-2.1-2.1h-10.9v-7.8h13.9 c0.3,0,0.5-0.2,0.5-0.5c0-1.1-0.9-2.1-2.1-2.1h-14.6c-0.3,0-0.5,0.2-0.5,0.5V44c0,0.3,0.2,0.5,0.5,0.5h16.3c0.3,0,0.5-0.2,0.5-0.5 C284.3,42.9,283.4,41.9,282.2,41.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M306.6,41.9h-11.2V23c0-1.1-0.9-2.1-2.1-2.1h-0.1c-0.3,0-0.5,0.2-0.5,0.5V44c0,0.3,0.2,0.5,0.5,0.5h15 c0.3,0,0.5-0.2,0.5-0.5C308.7,42.9,307.8,41.9,306.6,41.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M128.7,52.9c-0.1-0.2-0.3-0.4-0.6-0.4h-0.6c-0.6,0-1.1,0.3-1.3,0.8l-6.7,14.4c-0.2,0.4-0.2,1,0.1,1.4 c0.3,0.4,0.7,0.7,1.2,0.7c0.3,0,0.5-0.1,0.6-0.4l1.8-4.1h8.5l1.6,3.6c0.2,0.5,0.7,0.8,1.3,0.8h0.8c0.2,0,0.4-0.1,0.6-0.3 c0.1-0.2,0.1-0.4,0-0.6L128.7,52.9z M124.3,63l3.2-6.9l3.2,6.9H124.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M153.9,60.3h-5.4c-1,0-1.7,0.8-1.7,1.7c0,0.4,0.3,0.7,0.7,0.7h4.7v3.6c-1,0.7-2.6,1.5-4.4,1.5 c-3.7,0-6.2-2.5-6.2-6.5c0-3.7,2.5-6.4,5.9-6.4c2.4,0,3.6,0.8,4.7,1.7c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.4-0.2 c0.3-0.4,0.5-0.9,0.4-1.4c-0.1-0.5-0.3-0.9-0.7-1.2c-1.5-1-3.1-1.5-5.2-1.5c-5.3,0-8.5,4.5-8.5,8.8v0c0,5.2,3.6,8.8,8.6,8.8 c2.4,0,4.8-0.9,6.7-2.5c0.1-0.1,0.2-0.3,0.2-0.5v-6.1C154.6,60.6,154.3,60.3,153.9,60.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M169.5,62.8c2.6-0.7,4.1-2.5,4.1-5c0-1.3-0.5-2.5-1.4-3.4c-1.1-1.1-2.9-1.8-4.9-1.8h-6.7 c-0.4,0-0.7,0.3-0.7,0.7V68c0,1,0.8,1.8,1.8,1.8c0.4,0,0.7-0.3,0.7-0.7v-5.9h4.2l4.9,6.3c0.1,0.2,0.3,0.3,0.5,0.3h1.5 c0.2,0,0.5-0.1,0.6-0.4c0.1-0.2,0.1-0.5-0.1-0.7L169.5,62.8z M162.5,55h4.8c2.5,0,3.9,1,3.9,2.9c0,2.2-2.1,3-4,3h-4.7V55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M180.8,52.6c-1,0-1.8,0.8-1.8,1.8v14.7c0,0.4,0.3,0.6,0.7,0.6c1,0,1.8-0.8,1.8-1.8V53.3 C181.5,52.9,181.2,52.6,180.8,52.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M199.6,66.1c-1.3,1.1-2.6,1.6-4.3,1.6c-3.4,0-6.1-2.8-6.1-6.5c0-3.7,2.6-6.4,6-6.4c1.5,0,2.8,0.5,4.1,1.4 c0.8,0.6,1.9,0.6,2.6-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.5c-1.5-1.4-3.4-2.7-6.6-2.7c-4.8,0-8.6,3.9-8.6,8.8v0 c0,5,3.7,8.8,8.5,8.8c3.3,0,5.3-1.5,6.8-2.9c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.5C201.4,65.5,200.4,65.5,199.6,66.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M220.1,52.6c-1,0-1.8,0.8-1.8,1.8v8.1c0,3.3-1.6,5.1-4.6,5.1c-3,0-4.7-1.9-4.7-5.2v-9.1 c0-0.4-0.3-0.7-0.7-0.7c-1,0-1.8,0.8-1.8,1.8v8.1c0,4.5,2.8,7.5,7.2,7.5c4.4,0,7.2-2.9,7.2-7.6v-9.1 C220.8,52.9,220.5,52.6,220.1,52.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M236.4,67.4h-7.6V53.3c0-0.4-0.3-0.7-0.7-0.7c-1,0-1.8,0.8-1.8,1.8v14.7c0,0.4,0.3,0.7,0.7,0.7h10.5 c0.4,0,0.7-0.3,0.7-0.7C238.2,68.2,237.4,67.4,236.4,67.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M252.4,52.6h-11.2c-1,0-1.7,0.8-1.7,1.7c0,0.4,0.3,0.7,0.7,0.7h4.9v13c0,1,0.8,1.7,1.7,1.7h0.1 c0.4,0,0.7-0.3,0.7-0.6V55h3.8c1,0,1.7-0.8,1.7-1.7C253,52.9,252.7,52.6,252.4,52.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M271.2,52.6c-1,0-1.8,0.8-1.8,1.8v8.1c0,3.3-1.6,5.1-4.6,5.1c-3,0-4.7-1.9-4.7-5.2v-9.1 c0-0.4-0.3-0.7-0.7-0.7c-1,0-1.8,0.8-1.8,1.8v8.1c0,4.5,2.8,7.5,7.2,7.5c4.4,0,7.2-2.9,7.2-7.6v-9.1 C271.8,52.9,271.5,52.6,271.2,52.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M286.9,62.8c2.6-0.7,4.1-2.5,4.1-5c0-1.3-0.5-2.5-1.4-3.4c-1.1-1.1-2.9-1.8-4.9-1.8h-6.7 c-0.4,0-0.7,0.3-0.7,0.7v14.9c0,1,0.8,1.8,1.8,1.8c0.4,0,0.7-0.3,0.7-0.7v-6.2h4.2l4.9,6.3c0.1,0.2,0.3,0.3,0.5,0.3h1.5 c0.2,0,0.5-0.1,0.6-0.4c0.1-0.2,0.1-0.5-0.1-0.7L286.9,62.8z M279.9,55h4.8c2.5,0,3.9,1,3.9,2.9c0,2.2-2.1,3-4,3h-4.7V55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M307.3,67.4h-8.5v-5.1h8.4c0.4,0,0.7-0.3,0.7-0.7c0-1-0.8-1.7-1.7-1.7h-7.4V55h9.5c0.4,0,0.7-0.3,0.7-0.7 c0-1-0.8-1.7-1.7-1.7h-10.2c-0.4,0-0.7,0.3-0.7,0.7v15.8c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2h11.4 c0.4,0,0.7-0.3,0.7-0.7C309,68.2,308.2,67.4,307.3,67.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M84.3,48.3c-0.1-2.9-0.4-5.7-1.1-8.4c-0.2-0.7-0.3-1.4-0.5-2c-0.2-0.7-0.4-1.3-0.7-2c-0.2-0.7-0.5-1.3-0.8-2 c-0.2-0.7-0.6-1.3-0.9-1.9c-1.2-2.5-2.7-4.9-4.4-7.1c-1.7-2.2-3.7-4.2-5.9-5.9c-2.2-1.8-4.5-3.3-7-4.5c-2.5-1.3-5.2-2.2-7.9-2.9 c-5.5-1.3-11.2-1.4-16.9-0.3c5.4-1.8,11.4-2.2,17.2-1.1c2.9,0.5,5.7,1.5,8.3,2.7c2.7,1.2,5.2,2.8,7.5,4.6c2.3,1.9,4.3,4,6.1,6.3 c1.8,2.3,3.2,4.9,4.4,7.6c1.1,2.7,1.9,5.5,2.4,8.4C84.6,42.6,84.6,45.5,84.3,48.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M75.5,62.5C64.4,71,64.3,80.5,62.6,83.3c-3.4,1.4-7.1,2.4-10.8,2.8c-4.4,0.5-9,0.3-13.4-0.7 c-2.2-0.5-4.4-1.2-6.4-2c-2.1-0.8-4.1-1.8-6-3c-3.8-2.4-7.3-5.3-10.2-8.8C14.3,69.8,13,68,11.8,66c-1.2-2-2.1-4-3-6.1 c-0.8-2.1-1.5-4.3-1.9-6.6c-0.4-2.2-0.7-4.5-0.8-6.8c-0.3-9.1,2.4-18.5,7.9-26C19.5,13,27.5,7.3,36.5,4.7c4.5-1.3,9.2-1.9,14-1.7 c2.4,0.1,4.7,0.4,7,0.9c2.3,0.5,4.6,1.2,6.8,2c8.9,3.4,16.5,9.9,21.5,18.1c2.5,4.1,4.3,8.6,5.3,13.3c1,4.7,1.2,9.6,0.6,14.4 c0.7-4.8,0.7-9.7-0.2-14.5c-0.9-4.8-2.5-9.4-4.9-13.7C81.9,15,74.2,8,65,4.2C55.9,0.2,45.5-0.5,35.8,2c-9.7,2.5-18.5,8.3-24.7,16.3 c-6.2,8-9.6,18.1-9.6,28.3c0,2.5,0.2,5.1,0.6,7.6c0.4,2.5,1.1,5,1.9,7.4c0.8,2.4,1.9,4.8,3.1,7c1.2,2.2,2.7,4.4,4.2,6.4 c3.2,4.1,7,7.6,11.4,10.4c2.2,1.4,4.5,2.6,6.8,3.7c2.4,1,4.8,1.9,7.4,2.5c5,1.3,10.3,1.7,15.5,1.3c5-0.4,9.9-1.6,14.5-3.5 c2.8,0.5,12.9,1.8,19.9-4.9c8.2-7.9,7.4-15,13.3-20.6c5.8-5.6,9.2-4.9,9.2-4.9S89.4,51.7,75.5,62.5 M87.5,70.2 c-0.8,1-1.6,2.1-2.5,3.1c-1.8,2-3.7,3.8-5.8,5.5c-2.1,1.6-4.3,3.2-6.7,4.4c-1.2,0.6-2.4,1.2-3.7,1.6c-1.3,0.5-2.5,0.9-3.9,1 c2.5-0.9,4.8-2.1,7.1-3.5c2.2-1.4,4.4-2.9,6.4-4.5c1-0.8,2-1.6,3-2.5c0.5-0.4,1-0.8,1.5-1.3c0.5-0.5,0.9-0.9,1.4-1.4 c0.5-0.4,0.9-0.9,1.4-1.4l1.4-1.4c0.9-1,1.8-2,2.7-2.9C89,68,88.3,69.1,87.5,70.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M64.2,28.8H52.5l-0.2,0.1c-0.4,0.1-0.8,0.2-1.3,0.3c-2.3,0.7-4.5,1.8-6.2,3.5c-0.9,0.9-1.6,1.9-2.1,3 c-0.4,0.8-0.6,1.7-0.8,2.6v23.2c0,0.9,0.1,1.8,0.3,2.5c1.6,4.1,4.3,6.1,8,6.1l0.2-0.2V37.5h6l1.6-0.2c4.2-1.6,6.4-4.3,6.4-8.2 L64.2,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M42.3,35.5c0.4-1.2,1-2.4,1.8-3.4c0.8-1,1.8-1.9,2.9-2.7c0.3-0.2,0.6-0.4,1-0.6h-6.1h-5.5 c-0.7,0-1.5,0.1-2.4,0.3c-4,1.7-6,4.5-6,8.2l0.2,0.2h5.3l8.4-0.1C41.9,36.8,42.1,36.2,42.3,35.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTahweelargiculture);
export default __webpack_public_path__ + "static/media/Tahweelargiculture.48f6c229bb3f9b0df0e372f708e585d2.svg";
export { ForwardRef as ReactComponent };